async function loadHotspots() {
  const res = await fetch('./hotspots.json');
  const data = await res.json();
  return data;
}

async function initPannellum() {
  const panorama = document.getElementById('pannellum');
  if (!panorama) return;

  const hotspots = await loadHotspots();

  const scenes = Object.fromEntries(
    (hotspots.scenes ?? [])
      .filter(scene => scene?.panorama)
      .map((scene, index) => [
        `scene${index + 1}`,
        {
          panorama: scene.panorama,
          hotSpots: (scene.hotspots ?? []).map(h => ({
            pitch: h.pitch,
            yaw: h.yaw,
            createTooltipFunc: hotspotTooltip,
            createTooltipArgs: {
              img: h.img,
              title: h.title,
              text: h.text,
            },
            clickHandlerFunc: showCard,
          })),
        },
      ])
  );

  const viewer = pannellum.viewer(panorama, {
    default: {
      // mouseZoom: 'fullscreenonly',
      mouseZoom: false,
      showControls: false,
      showFullscreenCtrl: false,
      firstScene: 'scene1',
      type: 'equirectangular',
      sceneFadeDuration: 1000,
      pitch: 6.735,
      yaw: 153.567,
      preview: hotspots.preview,
      autoLoad: false,
    },
    scenes,
  });

  function showCard(event, args) {
    const hotSpotDiv = event.currentTarget;
    const card = hotSpotDiv.querySelector('.card-pano');

    if (!card) return;

    const isAlreadyOpen = card.classList.contains('is-open');

    document.querySelectorAll('.card-pano.is-open').forEach(openCard => {
      openCard.classList.remove('is-open');
      openCard.parentElement.classList.remove('is-open');
    });

    if (!isAlreadyOpen) {
      hotSpotDiv.classList.add('is-open');
      card.classList.add('is-open');
    }
  }

  function hotspotTooltip(hotSpotDiv, args) {
    const wrapper = document.createElement('div');
    wrapper.className = 'card-pano';

    const imgBox = document.createElement('div');
    imgBox.className = 'card-pano__img ibg';

    const img = document.createElement('img');
    img.src = args.img;

    imgBox.appendChild(img);

    const content = document.createElement('div');
    content.className = 'card-pano__content';

    const title = document.createElement('h4');
    title.className = 'card-pano__title';
    title.textContent = args.title;

    const text = document.createElement('p');
    text.className = 'card-pano__text';
    text.innerHTML = args.text;

    content.appendChild(title);
    content.appendChild(text);

    wrapper.appendChild(imgBox);
    wrapper.appendChild(content);
    hotSpotDiv.appendChild(wrapper);
  }

  const sceneButtons = document.querySelectorAll('.panorama__scene');
  let canClick = true;

  sceneButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      if (!canClick) return;

      if (btn.classList.contains('is-current')) return;

      const sceneName = btn.dataset.scene;

      canClick = false;

      sceneButtons.forEach(b => b.classList.remove('is-current'));
      btn.classList.add('is-current');

      viewer.loadScene(sceneName);

      viewer.on('scenechange', () => {
        canClick = true;
      });
    });
  });

  viewer.on('load', () => {
    canClick = true;
    console.log('scene loaded');
  });

  // Копируем в буфер обмена
  viewer.on('dblclick', function () {
    const pitch = viewer.getPitch().toFixed(3);
    const yaw = viewer.getYaw().toFixed(3);

    const coords = `"pitch": ${pitch},\n"yaw": ${yaw},`;

    navigator.clipboard
      .writeText(coords)
      .then(() => console.log('Скопировано:', coords))
      .catch(err => console.error('Ошибка копирования:', err));
  });
}

document.addEventListener('DOMContentLoaded', initPannellum);
